import { render } from "./MaoCardExhibition.vue?vue&type=template&id=7827c3af&scoped=true"
import script from "./MaoCardExhibition.vue?vue&type=script&lang=js"
export * from "./MaoCardExhibition.vue?vue&type=script&lang=js"

import "./MaoCardExhibition.vue?vue&type=style&index=0&id=7827c3af&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7827c3af"]])

export default __exports__